import { Client } from '@stomp/stompjs'
import SockJS from 'sockjs-client'

class WSClient {
  constructor() {
    this.client = null
    this.subscriptions = []
    this.onMessageHandlers = {}
    this.connected = false
    this.heartbeatTimer = null
  }

  connect(playerId, roomId, onConnect, onError) {
    if (this.client) {
      this.disconnect()
    }

    this.playerId = playerId
    this.roomId = roomId

    this.client = new Client({
      webSocketFactory: () => new SockJS(localStorage.baseUrl + '/ws/poker'),
      connectHeaders: {
        playerId: playerId,
        roomId: roomId
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: (frame) => {
        this.connected = true
        this.subscribeToRoom(roomId)
        this.subscribeToPlayer(roomId, playerId)
        this.startHeartbeat()
        this.send(`/app/room/${roomId}/chat/history`, { playerId })
        if (onConnect) onConnect(frame)
      },
      onDisconnect: () => {
        this.connected = false
        this.stopHeartbeat()
      },
      onStompError: (frame) => {
        if (onError) onError(frame)
      }
    })

    this.client.activate()
  }

  subscribeToRoom(roomId) {
    if (!this.client) return
    const sub = this.client.subscribe(`/topic/room/${roomId}`, (message) => {
      try {
        const body = JSON.parse(message.body)
        this.emit(body.type, body)
      } catch (e) {
        console.error('WS parse error:', e)
      }
    })
    this.subscriptions.push(sub)
  }

  subscribeToPlayer(roomId, playerId) {
    if (!this.client) return
    const sub = this.client.subscribe(`/topic/room/${roomId}/player/${playerId}`, (message) => {
      try {
        const body = JSON.parse(message.body)
        this.emit(body.type, body)
      } catch (e) {
        console.error('WS parse error:', e)
      }
    })
    this.subscriptions.push(sub)
  }

  send(destination, body) {
    if (this.client && this.connected) {
      this.client.publish({ destination, body: JSON.stringify(body) })
    }
  }

  startHeartbeat() {
    this.stopHeartbeat()
    this.sendHeartbeat()
    this.heartbeatTimer = setInterval(() => {
      this.sendHeartbeat()
    }, 2000)
  }

  sendHeartbeat() {
    if (!this.playerId || !this.roomId) return
    this.send(`/app/room/${this.roomId}/heartbeat`, {
      playerId: this.playerId
    })
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  on(type, handler) {
    if (!this.onMessageHandlers[type]) {
      this.onMessageHandlers[type] = []
    }
    this.onMessageHandlers[type].push(handler)
    return () => this.off(type, handler)
  }

  off(type, handler) {
    if (this.onMessageHandlers[type]) {
      this.onMessageHandlers[type] = this.onMessageHandlers[type].filter(h => h !== handler)
    }
  }

  emit(type, data) {
    const handlers = this.onMessageHandlers[type] || []
    handlers.forEach(h => h(data))
  }

  disconnect() {
    this.stopHeartbeat()
    this.subscriptions.forEach(sub => sub.unsubscribe())
    this.subscriptions = []
    if (this.client) {
      this.client.deactivate()
      this.client = null
    }
    this.connected = false
  }
}

export default new WSClient()
